export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_10016_ADD_BEHAVIOUR': 'Add Behaviour',
    '_10018_SELECT_ADDITIONAL_BEHAVIOURS': 'Select additional Behaviours'
};
